
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","viewBox":"0 0 128 199.4","enable-background":"new 0 0 128 199.4","xml:space":"preserve"}},[_c('g',[_c('polygon',{attrs:{"fill":"#E3E3E3","points":"99.7,0 0,99.7 99.7,199.4 128,171.1 56.6,99.7 128,28.3 \t"}})])])
      }
    
      }
    